:host {
  --grid-min-width: 100%;
}

.wrapper {
  max-width: 700px;
  min-width: 700px;
  width: 100%;
}

gz-data-table {
  --column-max-width: 600px;
  --cell-padding: 0;
}
